import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccountListFilter  {
    _originalTypeClassName = "zERP.BO.BankAccountListFilter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccountListFilter.translate = translateService;
}
this.From = null;
this.To = null;
this.BankAccountListFilterKey = null;
this._key = this.BankAccountListFilterKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
private _BankAccountListFilterKey:any;
get BankAccountListFilterKey(): any {
    return this._BankAccountListFilterKey;
  }
set BankAccountListFilterKey(value: any) {
    this._BankAccountListFilterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BankAccountListFilterKey == null || $this.BankAccountListFilterKey == 0;
            }


}